<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    History Pembayaran
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="bg-white">
            <div class="body">
                <div class="ml10 mr10 mt10">
                    <div class="tulang" v-show="get.data.loading">
                        <Loading style="height: 50px;" class="mb20">
                        </Loading>
                        <Loading style="height: 50px;" class="mb20">
                        </Loading>
                        <Loading style="height: 50px;" class="mb20">
                        </Loading>
                    </div>
                </div>
                <div class="bt-1 pl10 pr10 pt10 pb10 m0"  v-for="(u, index) in get.data.list"  v-show="!get.data.loading">
                    <div class="box-horizontal" @click="met.detail(u)">
                        <div class="primary-bg-round p10 text-center mr10">
                            <span class="block white">
                                <strong class="f12">{{myGlobal.BulanSOnly(u.tanggal)}}</strong>
                            </span>
                            <span class="block white f12">
                                {{myGlobal.TahunOnly(u.tanggal)}}
                            </span>
                        </div>
                        <div class="flex-1">
                            <span class="block f13 hitam" v-if="u.is_isolir == null">
                                {{"Pembayaran By "+u.by_admin}}
                            </span>
                            <span class="block f13 red" v-else>
                                {{"Isolir By "+u.by_admin}}
                            </span>
                            <span class="block f10 gray">
                                {{"Tgl Bayar :  "+myGlobal.tglIndo(u.bayar_tanggal)}}
                            </span>
                            <span class="block">
                                <div class="box-horizontal m0" v-if="u.is_isolir == null">
                                    <span class="hitam">Via :&nbsp;</span>
                                    <span class="green" style="text-transform: uppercase" v-if="u.via != null ">{{u.via}}</span>
                                    <span class="green" style="text-transform: uppercase" v-else>CASH</span>
                                </div>
                            </span>
                        </div>
                        <div class="text-right mr10">
                            <span class="block primary-color mb5">
                                {{myGlobal.ribu(u.paket_tarif)}}
                            </span>
                            <span class="block text-center " v-if="u.is_isolir == null">
                                <span class="block bg-round-green p5 white" v-if="u.stat_via_online == null">
                                    LUNAS
                                </span>
                                <span v-else>
                                    <span class="block bg-round-green p5 white" v-if="u.stat_via_online == 'done'">LUNAS</span>
                                    <span v-else>
                                        <span class="block bg-round-yellow p5 white">PENDING</span>
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    components: { 
        'Loading': Loading
    },
    setup() {
        const get = {
            data: reactive({
                this: '',
                loading: true,
                list: []
            }),
            list() {
                var datax = {
                    token: 'TangTung ' +sessionStorage.getItem('tokenu'),
                    limit: "all"
                };
            
                var apiUrl = inter.History();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        this.data.list = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }

                    this.data.loading = false;
                })
            }
        }
        const met = {
            back() {
                window.history.back();
            },
            detail(xdata) {
                router.push({ 
                    name: 'history-detail', 
                    params: {
                        data: xdata
                    } 
                });
            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx,
            myGlobal
        }

    },
    mounted () {        
        this.redirectx.checkApp();

        sessionStorage.removeItem("rincianDetail");

        this.get.list();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/History/main.vue